var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-primary seth-set px-6 py-12 flex justify-between"},[_c('div',{staticClass:"w-full"},[_c('h2',{staticClass:"text-white text-2xl font-semibold"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-white fsize12 w-1/2 mt-2"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])]),_c('NotificationUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }